import {React} from "react";
import {motion} from "framer-motion";
import {ButtonDrawOutline, ButtonDrawOutlineAlt, ButtonDrawOutlineWhite} from "../../components/common"; 
import {Link} from "react-router-dom";

import {BouncyCardsFeatures, HorizontalScrollCarousel} from "./components";

const Tester = () => {
    return (
        
        <div>

            <section className="hero" >
                <div className="hero-image"></div>
                <section className="landing-content" class="  absolute flex text-white top-0 justify-center items-center h-[70vh] lg:h-screen w-screen flex-col">
                    <h1 class="mx-5 mb-5 text-4xl lg:text-5xl font-bold ">
                    Developing Advanced Robotic Systems for Assistive Applications                    </h1>
                    <p class="mx-5 text-lg lg:text-2xl mb-7">
                        Engineered to navigate treacherous waters and deliver critical aid when every second counts.
                    </p>

                    <Link to={"./inserr"} class="  my-3 mx-10 drop-shadow-lg "> 
                    <ButtonDrawOutline>Explore Products →</ButtonDrawOutline>
                    </Link>

                    </section>
            </section>            
            <div class="bg-green-900 text-center py-4 lg:px-4">
                <div class="p-2 bg-green-800 items-center text-green-100 leading-none lg:rounded-full flex lg:inline-flex" role="alert">
                    <span class="flex rounded-full bg-emerald-500 uppercase px-2 py-1 text-xs font-bold mr-3">New</span>
                    <span class="font-semibold mr-2 text-left flex-auto">
                        Get the newest updates on our roadmap blog
                    </span>
                    <svg class="fill-current opacity-75 h-4 w-4" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path d="M12.95 10.707l.707-.707L8 4.343 6.586 5.757 10.828 10l-4.242 4.243L8 15.657l4.95-4.95z"/></svg>
                </div>
            </div>
            <section class="place-items-center w-screen  justify-center flex-wrap align-center lg:grid">
                
                <section class="lg:w-[70vw] h-[60vh] lg:h-screen items-center justify-center place-items-center lg:flex lg:p-10 lg:m-10 box-sizing">
                    <div class="lg:float-left lg:w-1/2 p-5 my-10 lg:p-10 lg:m-10 box-sizing  place-items-center">
                        <h1 class="text-6xl mt-10 font-bold">Meet INSERR.</h1>
                        <p class="text-xl lg:text-justify my-5">
                            INSERR is a groundbreaking Remotely Operated Vehicle (ROV) engineered for life-saving missions in zero-visibility underwater environments. Equipped with advanced navigation systems and life-sustaining equipment, INSERR is designed to locate and assist victims during underwater disasters, ensuring rapid and effective emergency response.                        </p>
                        <Link to={"./inserr"} class="bg-transparentpy-2 px-4">
                            <ButtonDrawOutlineAlt>Learn About INSERR →</ButtonDrawOutlineAlt>
                        </Link>
                    </div>
                    <div class="lg:float-right  lg:p-10 lg:m-10 box-sizing">
                    <img src={require("../../assets/img/inserr/IMG_5227.JPG")} alt="INSERR" class="object-cover lg:h-[45vh]" />
                    </div>
                </section>

                    <HorizontalScrollCarousel />

                <section>
                    <div class="mt-60">
                    <BouncyCardsFeatures />
                    </div>
                </section>
                <div class=" m-5 h-[50vh] lg:h-[80vh] lg:w-[70vw] align-center items-center justify-center flex">
                <div class=" w-screen  justify-center flex lg:p-10 lg:m-10 box-sizing">
                    <div class="grid grid-cols-12 w-full h-80 p-5 lg:p-10 bg-white border border-gray-200 rounded-lg shadow dark:bg-gray-800 dark:border-gray-700">
                        <div class="w-full col-span-12 ">
                            <h5 class="mb-4 text-3xl lg:text-4xl font-bold  text-gray-900 dark:text-white ">Our team for your sucess</h5>
                        <p class="lg:mb-10 text-base lg:text-xl font-normal text-gray-700 dark:text-gray-400">Our team is here to help you do more. Discover the story behind the team and the company. Hear about what we offer, the support, services, and resources available to empower your customer journey and help you unlock the full value of your robotics solutions.</p>
                        </div>
                        <div class="lg:col-span-3 flex lg:flex-column ">
                        <Link to={"/about"} class=" h-12  font-semibold  py-2 px-4  rounded">
                        <ButtonDrawOutlineWhite>Learn More →</ButtonDrawOutlineWhite>
                        </Link>
                        </div>
                    </div>
                </div>
                </div>
   

                <div class=" ">
                <div>
                    <div class="p-5 m-5 lg:h-[80vh] h-screen w-screen  justify-center grid box-sizing ">
                        <div class="h-full">
                            <h1 class="text-4xl bold my-10 font-medium w-full ">Our Partners</h1>
                        </div>
                        <div class="px-2">
                            <div class=" m-2 mb-4 grid grid-cols-12 gap-4">

                                    <motion.div whileHover={{ scale: 1.05 }} class="max-w-sm rounded-lg col-span-12 md:col-span-4">
                                        <a href="http://macanista.com/">
                                            <img class="rounded-t-lg object-scale-down border bg-white" src={require("../../assets/img/partners/369-logo.png")} style={{height:"15em",width:"25em"}} alt="coast" />
                                        </a>
                                        <div class="p-5">
                                            <a href="https://369cooptown.com/">
                                                <h5 class="mb-2 text-2xl font-bold tracking-tight text-gray-900 dark:text-black">369 Coop</h5>
                                            </a>
                                            <p class="mb-3 font-normal text-black dark:text-black">Startup incubation and consultation</p>
                                        </div>
                                    </motion.div>

                                    <motion.div whileHover={{ scale: 1.05 }}class="max-w-sm  rounded-lg col-span-12 md:col-span-4">
                                        <a href="https://www.makermods.ai/">
                                            <img class="rounded-t-lg object-cover border bg-white" src={require("../../assets/img/partners/makermodslogo.png")} style={{height:"15em",width:"25em"}} alt="" />
                                        </a>
                                        <div class="p-5">
                                            <a href="https://www.makermods.ai/">
                                                <h5 class="mb-2 text-2xl font-bold tracking-tight text-gray-900 dark:text-black">MakerMods</h5>
                                            </a>
                                            <p class="mb-3 font-normal text-black dark:text-black">Revolutionary AI-driven robotics modules</p>
                                        </div>
                                    </motion.div>

                                    <motion.div whileHover={{ scale: 1.05 }} class="max-w-sm col-span-12 md:col-span-4">
                                        <a href="https://www.instagram.com/fishlogicrov/">
                                            <img class="rounded-t-lg object-auto border bg-white" src={require("../../assets/img/partners/FishLogicLogo.png")} style={{height:"15em" ,width:"25em"}} alt="" />
                                        </a>
                                        <div class="p-5">
                                            <a href="https://www.instagram.com/fishlogicrov/">
                                                <h5 class="mb-2 text-2xl font-bold tracking-tight text-gray-900 dark:text-black">Fish Logic</h5>
                                            </a>
                                            <p class="mb-3 font-normal text-black dark:text-black">Award winning underwater robotics team.</p>
                                        </div>
                                    </motion.div>
                                
                            </div>
                            
                        </div>
                    </div>
                </div>
                <div class="w-screen  justify-center flex mb-40  box-sizing">
                <div class="w-[90vw] lg:w-3/5 h-[40vh]  justify-center flex  box-sizing">
                <div class="h-full w-screen bg-gradient-to-r from-green-500 to-teal-900 text-white">


                    <div class="p-5 mt-5">
                        <h2 class=" text-5xl lg:text-6xl m-5 font-semibold">Saving lives faster than ever</h2>
                        <p class="m-5 text-xl text-justify">
                        At Macanista Robotics, our vision is to revolutionize robotics by developing innovative technology solutions that enhance safety, efficiency, and exploration across various industries. We are committed to pushing the boundaries of technology to address complex challenges in marine environments, ensuring a sustainable and prosperous future for our planet. 
                        </p>
                        <Link to={"/inserr"} class="text-center font-semibold hover:text-black py-2 px-4 ">
                            <ButtonDrawOutline>Learn About More →</ButtonDrawOutline>
                        </Link>
                    </div>
                </div>
                </div>
                </div>
                </div>
            </section>      
        </div>
    );
};



export default Tester;
